"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.My529Logo = My529Logo;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* My529Logo Component
*
*/
function My529Logo(_ref) {
  var color = _ref.color,
      height = _ref.height,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 324 105.7",
    style: {
      enableBbackground: 'new 0 0 324 105.7'
    },
    xmlSpace: "preserve",
    height: height || '50px',
    className: className || ''
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "SVGID_1_",
    x: "-40.2",
    y: "-19.8",
    width: "405.3",
    height: "149.3"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      clipPath: 'SVGID_2_',
      fill: color || '#231F20'
    },
    d: "M69.1,84.1V49.9c0-7.7-4.9-10.3-9.4-10.3c-4.4,0-9.4,2.6-9.4,10V84h-14v-34c0-7.7-4.9-10.3-9.4-10.3\r c-4.4,0-9.4,2.6-9.4,10.3v34.1H3.5V27.7h13.7v5.2c3.7-3.8,8.9-5.8,14.1-5.8c6.3,0,11.4,2.3,14.9,7.1c4.7-5,9.8-7.1,16.8-7.1\r c5.6,0,10.7,1.9,13.9,5c4.5,4.5,6.2,9.8,6.2,16v36H69.1z"
  }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "SVGID_3_",
    x: "-40.2",
    y: "-19.8",
    width: "405.3",
    height: "149.3"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      clipPath: 'SVGID_4_',
      fill: color || '#231F20'
    },
    d: "M113.7,93.2c-1.2,3.1-2.5,5.6-4.3,7.2c-3.2,3.2-7.5,4.4-12.1,4.4h-5.6V92h3.2c4,0,5.6-0.9,7-5.1l2.4-6.9\r L85.2,27.7H100l11.7,34.8L130,7h14.8L113.7,93.2z"
  }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "SVGID_5_",
    x: "-40.2",
    y: "-19.8",
    width: "405.3",
    height: "149.3"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      clipPath: 'SVGID_6_',
      fill: color || '#0071CE'
    },
    d: "M187.6,78.4c-3.4,3.4-9,6.3-16.9,6.3c-8.1,0-13.9-2.8-17.2-6.2c-4.7-4.7-5.8-10.4-6.3-16h14.1\r c0.7,6,3.6,9.5,9.4,9.5c2.7,0,5-0.7,6.8-2.5c2.5-2.5,3.1-6.6,3.1-11.5c0-8.9-2.6-13.9-9.4-13.9c-5.7,0-8.3,3.2-9.4,6.3h-12.9V7\r h44v12.7h-31.2v16.6c2-1.9,6.4-3.9,11.6-3.9c6.4,0,11.3,2,14.3,5.2c6,6,6.9,13.3,6.9,20.6C194.5,66.8,193.3,72.8,187.6,78.4"
  }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "SVGID_7_",
    x: "-40.2",
    y: "-19.8",
    width: "405.3",
    height: "149.3"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      clipPath: 'SVGID_8_',
      fill: color || '#EF7622'
    },
    d: "M202.4,82.3V69.6l28.8-33.4c2.8-3.3,4-5.7,4-9.4c0-5.7-3.3-9.6-9.4-9.6c-4.6,0-9.4,2.4-9.4,9.8h-14.1\r c0-14.1,10.3-22.5,23.5-22.5c13.6,0,23.3,8.5,23.3,22.4c0,7.5-3,11.5-8.2,17.7l-21.6,25h29.7v12.7\r C249.2,82.3,202.4,82.3,202.4,82.3z"
  }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "SVGID_9_",
    x: "-40.2",
    y: "-19.8",
    width: "405.3",
    height: "149.3"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      clipPath: 'SVGID_10_',
      fill: color || '#00B550'
    },
    d: "M299.3,49l-16.4,33.3h-15.3l16.1-31.8c-1.9,0.7-3.9,0.9-5.7,0.9c-10.4,0-20.4-8.5-20.4-22.9\r c0-15.2,10.4-24.1,24.1-24.1c13.6,0,24.1,8.5,24.1,23.8C305.7,35.5,302.8,41.9,299.3,49 M281.6,17.2c-5.7,0-10,4.1-10,11.3\r c0,6.9,4,11.3,10,11.3c5.7,0,10-4.1,10-11.3C291.7,21.4,287.4,17.2,281.6,17.2"
  }))), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "SVGID_11_",
    x: "-40.2",
    y: "-19.8",
    width: "405.3",
    height: "149.3"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      clipPath: 'SVGID_12_',
      fill: color || '#00B550'
    },
    d: "M322.2,8.5c0,3.9-3.1,6.9-7,6.9s-7-3.1-7-6.9s3.1-6.9,7-6.9C319.3,1.6,322.2,4.7,322.2,8.5 M310,8.5\r c0,3.1,2.3,5.5,5.3,5.5c3,0,5.2-2.4,5.2-5.5S318.3,3,315.4,3C312.3,3,310,5.4,310,8.5 M314.2,12h-1.5V5.1\r c0.6-0.1,1.5-0.2,2.6-0.2c1.3,0,1.9,0.2,2.4,0.5c0.4,0.2,0.7,0.8,0.7,1.5s-0.6,1.3-1.4,1.5v0.1c0.7,0.2,1.1,0.7,1.3,1.7\r c0.2,1.1,0.4,1.4,0.5,1.7H317c-0.2-0.2-0.4-0.8-0.6-1.7c-0.1-0.7-0.6-1.1-1.4-1.1h-0.8V12L314.2,12z M314.2,8.1h0.7\r c0.8,0,1.5-0.2,1.5-0.9c0-0.6-0.5-1.1-1.4-1.1c-0.5,0-0.7,0-0.8,0.1L314.2,8.1L314.2,8.1z"
  })))));
}

My529Logo.propTypes = {
  color: _propTypes["default"].string,
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  className: _propTypes["default"].string
};
var _default = My529Logo;
exports["default"] = _default;